export default "__VITE_ASSET__DRHZJW6d__"